import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type TeamsListQueryParams = Parameters<typeof SSF.api.teamsList>[0];

export const keys = createQueryKeySet<TeamsListQueryParams>('teams');

export function useTeamsListQuery(params?: TeamsListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.teamsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}

export function useTeamsQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.teamsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
